import { render, staticRenderFns } from "./NormalTextPart.vue?vue&type=template&id=74461668&scoped=true&"
import script from "./NormalTextPart.vue?vue&type=script&lang=js&"
export * from "./NormalTextPart.vue?vue&type=script&lang=js&"
import style0 from "./NormalTextPart.vue?vue&type=style&index=0&id=74461668&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74461668",
  null
  
)

export default component.exports